/**
 * @generated SignedSource<<1245a58ce17437d710be07a7be3da634>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingBriefsSuggestedAction_note$data = {
  readonly id: string;
  readonly meetingBrief: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "MeetingBriefsSuggestedAction_note";
};
export type MeetingBriefsSuggestedAction_note$key = {
  readonly " $data"?: MeetingBriefsSuggestedAction_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingBriefsSuggestedAction_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingBriefsSuggestedAction_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingBrief",
      "kind": "LinkedField",
      "name": "meetingBrief",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "ce689697eb657e7598b93df3b5c318c7";

export default node;
